import { ComponentType, createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { ArdoqShapes } from './assets/ardoq/ArdoqShapes';
import { ArchimateShapes } from './assets/archimate/ArchimateShapes';
import { ArchimateIcons } from './assets/archimate/ArchimateIcons';
import { BpmnShapes } from './assets/bpmn/BpmnShapes';
import { BpmnIcons } from './assets/bpmn/BpmnIcons';
import { MarkerDefinitions } from './assets/MarkerDefinitions';
import { SvgTextureDefsDefinitions } from './assets/SvgTextureDefsDefinitions';
import { NotationStandard, standards } from './standards';
import { ASSETS_AND_TEST_CONTAINER_ID } from './const';
import { ArdoqIconCategory, ArdoqShape } from './types';
import { EdgyIcons } from './assets/edgy/EdgyIcons';
import { EdgyShapes } from './assets/edgy/EdgyShapes';

const Shapes: Record<string, ArdoqShape> = {
  none: {
    id: 'none',
    label: 'None',
    category: undefined,
  },
};

let SvgDefsHTML = '';
let svgWrapper: null | HTMLDivElement = null;

export const getSvgDefs = () => SvgDefsHTML;

const injectSvgDefs = () => {
  if (svgWrapper === null) return;
  svgWrapper.innerHTML = `<svg><defs>${getSvgDefs()}</defs></svg>`;
};

const loadSvgDefs = (template: ComponentType<unknown>) => {
  SvgDefsHTML += renderToStaticMarkup(createElement(template));
};

const registerShapes = (
  template: ComponentType<unknown>,
  category: ArdoqIconCategory
) => {
  new DOMParser()
    .parseFromString(renderToStaticMarkup(createElement(template)), 'text/html')
    .body.childNodes.forEach((element: any) => {
      if (!element.id || !element.dataset.label) {
        return;
      }
      Shapes[element.id] = {
        id: element.id,
        label: element.dataset.label,
        category,
      };
    });
};

export const initializeShapeAndMarkerDefinitions = () => {
  if (!document.getElementById(ASSETS_AND_TEST_CONTAINER_ID)) {
    const div = document.createElement('div');
    div.id = ASSETS_AND_TEST_CONTAINER_ID;
    div.setAttribute('aria-hidden', 'true');
    div.style.cssText = `
    height: 0;
    left: -1000px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 0;
  `;
    document.body.appendChild(div);
  }

  svgWrapper = document.createElement('div');
  svgWrapper.className = 'domTester';
  document
    .getElementById(ASSETS_AND_TEST_CONTAINER_ID)
    ?.appendChild(svgWrapper);

  loadSvgDefs(MarkerDefinitions);
  loadSvgDefs(SvgTextureDefsDefinitions);
  loadSvgDefs(ArdoqShapes);
  loadSvgDefs(ArchimateIcons);
  loadSvgDefs(ArchimateShapes);
  loadSvgDefs(BpmnIcons);
  loadSvgDefs(BpmnShapes);
  loadSvgDefs(EdgyIcons);
  loadSvgDefs(EdgyShapes);

  injectSvgDefs();

  registerShapes(ArdoqShapes, ArdoqIconCategory.Ardoq);
  registerShapes(ArchimateShapes, ArdoqIconCategory.ArchiMate);
  registerShapes(BpmnShapes, ArdoqIconCategory.BPMN);
  registerShapes(EdgyShapes, ArdoqIconCategory.EDGY);
};

export const getShapes = () => Shapes;

export const getStandard = (id: string): NotationStandard =>
  standards[id as keyof typeof standards];
export const getStandards = () => standards;
